import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { VERSION } from '../../settings'
import { Link } from 'react-router-dom'

export function Footer () {
  return (
    <div className={'footer'}>
      <Container>
        <Row>
          <Col>

            <p>&copy; 2018 &middot; Parkshield Collection &middot; v{VERSION}</p>
            <p><Link to='/admin'>Admin</Link></p>

          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/modules/Footer/Footer.jsx